export const teoriaCompatibilidadRedesEstandares = [
    {
      title: "¿Con qué redes son compatibles los contratos y estándares de Ethereum? Comparativa con TRON y BNB Chain",
      value: `
  Al crear contratos inteligentes y tokens, es fundamental saber **en qué redes blockchain se pueden desplegar** y **qué estándares debes utilizar**.  
  Aquí te explico las principales compatibilidades y diferencias entre Ethereum, TRON y BNB Chain.
  
  ---
  
  ### Redes compatibles con los estándares de Ethereum (EVM)
  
  La mayoría de los contratos inteligentes escritos para **Ethereum** usan el lenguaje **Solidity** y siguen los estándares ERC (como ERC20 y ERC721).  
  Muchas otras blockchains han adoptado la **Ethereum Virtual Machine (EVM)**, permitiendo desplegar los mismos contratos y tokens prácticamente sin cambios de código.
  
  **Principales redes EVM-compatibles:**
  - **Ethereum**
  - **Polygon (Matic)**
  - **BNB Chain** (antes Binance Smart Chain)
  - **Avalanche C-Chain**
  - **Fantom**
  - **Arbitrum**
  - **Optimism**
  - **Base**
  - **Cronos**
  - **Celo**
  - **Moonbeam** (Polkadot)
  
  En todas estas redes puedes desplegar contratos ERC20, ERC721, ERC1155, etc., y funcionarán igual que en Ethereum.
  
  ---
  
  ### Estándares de tokens en TRON
  
  TRON es una blockchain propia con su propio ecosistema y máquina virtual (**TVM: TRON Virtual Machine**).  
  No es EVM-compatible, pero su funcionamiento es muy similar.
  
  **Estándares de tokens en TRON:**
  - **TRC20:**  
    Es el equivalente al ERC20 de Ethereum. Sirve para crear tokens fungibles (criptomonedas, utilidades).
  - **TRC10:**  
    Un estándar más básico, no requiere contrato inteligente para su emisión (menos flexible que TRC20).
  - **TRC721:**  
    Similar al ERC721, utilizado para NFTs (tokens no fungibles) en la red TRON.
  
  **Diferencias principales con Ethereum:**
  - Los tokens en TRON se mueven con el activo nativo TRX y el manejo de tarifas (“energy”, “bandwidth”) es diferente.
  - El desarrollo es con Solidity, pero sobre la TVM (no EVM), así que algunas funciones avanzadas pueden variar o requerir adaptación.
  - Las direcciones en TRON tienen otro formato (empiezan con “T”, no con “0x”).
  
  ---
  
  ### Estándares de tokens en BNB Chain (Binance Smart Chain / BSC)
  
  **BNB Chain** es una blockchain EVM-compatible (puedes usar los mismos contratos que en Ethereum, sin cambios).
  
  **Estándares de tokens en BNB Chain:**
  - **BEP20:**  
    Es el equivalente directo al ERC20; prácticamente el mismo código, pero adaptado para la red BNB Chain.
  - **BEP721:**  
    Equivalente al ERC721, usado para NFTs.
  - **BEP1155:**  
    Equivalente al ERC1155, para tokens multi-activos.
  
  **Diferencias principales con Ethereum:**
  - Las tarifas de transacción en BNB Chain se pagan con **BNB** (no ETH).
  - Es mucho más rápida y económica para transferencias y despliegues, pero la seguridad y descentralización pueden ser menores en comparación con Ethereum.
  - El código de contratos y tokens es prácticamente igual al de Ethereum, así que puedes migrar fácilmente tus proyectos.
  
  ---
  
  ### Resumen visual
  
  | Red / Standard | Fungible (ERC20/BEP20/TRC20) | NFT (ERC721/BEP721/TRC721) | Multi-Activo (ERC1155/BEP1155) | Código base    | Compatible EVM |
  |----------------|------------------------------|----------------------------|-------------------------------|---------------|---------------|
  | Ethereum       | ERC20                        | ERC721                     | ERC1155                       | Solidity      | Sí            |
  | BNB Chain      | BEP20                        | BEP721                     | BEP1155                       | Solidity      | Sí            |
  | TRON           | TRC20                        | TRC721                     | (No estándar multi-asset)     | Solidity*     | No (usa TVM)  |
  
  *En TRON, Solidity es compatible pero con ligeras diferencias técnicas.
  
  ---
  
  **Conclusión:**  
  - Los estándares de Ethereum han sido adoptados en muchas blockchains EVM-compatibles, lo que facilita la migración de contratos y proyectos entre redes.
  - TRON tiene sus propios estándares y detalles técnicos, pero la lógica es muy similar.
  - BNB Chain usa los mismos contratos que Ethereum, solo cambiando el nombre del estándar (BEP en vez de ERC).
  
  Esto te permite crear tokens, NFTs o apps descentralizadas eligiendo la red que más te convenga en velocidad, costos y alcance.
  
  En la siguiente sección aprenderás a elegir el estándar adecuado y adaptar tu contrato si necesitas lanzar tu proyecto en varias blockchains.
  `
    }
  ];
  
  export default teoriaCompatibilidadRedesEstandares;
  